<template>
    <div
        class="container-fluid text-left page-card weflix-admin-editCupon"
        data-aos="fade-left"
        data-aos-duration="1500"
    >
        <h1 class="card-title mb-2">Editar Cupom</h1>
        <p class="card-subtitle mb-4 mb-md-0">Edite as informações do cupom</p>
        <hr class="page-card__divider mb-md-6" />

        <div class="row" v-if="hasReady">
            <div class="col-12 col-md-6 m-0 mb-3">
                <div>
                    <label class="labeld"
                        >Código do cupom<v-tooltip
                            text="Campo obrigatório"
                            location="top"
                        >
                            <template v-slot:activator="{ props }">
                                <fa
                                    v-bind="props"
                                    icon="fa-solid fa-circle-exclamation"
                                ></fa>
                            </template> </v-tooltip
                    ></label>
                </div>
                <div class="form-input">
                    <input
                        type="text"
                        required
                        class="inputd mb-1"
                        v-model="code"
                        placeholder="Off10"
                    />
                    <!-- <small class="alertText">Campo obrigatório e deve ser preenchido corretamente.</small> -->
                    <small>Nome comercial de sua coleção, uso externo.</small>
                </div>
            </div>

            <div class="col-12 col-md-6 m-0 mb-3">
                <div>
                    <label class="labeld"
                        >Desconto do cupom %<v-tooltip
                            text="Campo obrigatório"
                            location="top"
                        >
                            <template v-slot:activator="{ props }">
                                <fa
                                    v-bind="props"
                                    icon="fa-solid fa-circle-exclamation"
                                ></fa>
                            </template> </v-tooltip
                    ></label>
                </div>
                <div class="form-input">
                    <input
                        type="text"
                        required
                        class="inputd mb-1"
                        v-model="discount"
                        placeholder="10"
                    />
                    <!-- <small class="alertText">Campo obrigatório e deve ser preenchido corretamente.</small> -->
                    <small>Nome comercial de sua coleção, uso externo.</small>
                </div>
            </div>

            <!-- <div class="col-form-inner col-12">
                  <div class="col-12 col-md-6 m-0 mb-3">
                    <div class="labeld">
                      <label>Plano que receberá o desconto<v-tooltip text="Campo obrigatório" location="top">
                        <template v-slot:activator="{ props }">
                          <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                        </template>
                      </v-tooltip></label>
                    </div>
                    <div class="form-input">
                      <select
                        required
                        class="inputd"
                        v-model="selectedPlan"
                      >
                        <option value="" disabled selected>Planos</option>
                        <option :value="plan.id" v-for="plan in plans" :key="plan.id">{{ plan.name }}</option>
                      </select>
                      <small>Escolha a frequência de renovação do plano.</small>
                    </div>
                  </div>
              </div> -->

            <div class="col-12 col-md-6 m-0 mb-3">
                <div>
                    <label class="labeld" for="toggleStatuus"
                        >Status<v-tooltip
                            text="Campo obrigatório"
                            location="top"
                        >
                            <template v-slot:activator="{ props }">
                                <fa
                                    v-bind="props"
                                    icon="fa-solid fa-circle-exclamation"
                                ></fa>
                            </template> </v-tooltip
                    ></label>
                </div>
                <div class="form-input web-mobile-form">
                    <CustomToggle
                        class="mb-1"
                        id="toggleStatuus"
                        v-model="status"
                    />
                    <small
                        >Ative para permitir que o cupom seja utilizado.</small
                    >
                </div>
            </div>

            <div class="col-12 col-md-6 m-0 mb-3">
                <div>
                    <label class="labeld"
                        >Data de Expiração<v-tooltip
                            text="Campo obrigatório"
                            location="top"
                        >
                            <template v-slot:activator="{ props }">
                                <fa
                                    v-bind="props"
                                    icon="fa-solid fa-circle-exclamation"
                                ></fa>
                            </template> </v-tooltip
                    ></label>
                </div>
                <div class="form-input">
                    <input
                        type="date"
                        required
                        class="inputd"
                        v-model="expired"
                    />
                </div>
            </div>
            <hr class="page-card__divider" />
        </div>
        <div class="d-flex align-items-center justify-content-center justify-content-md-end ga-3 mt-5 mt-md-7">
            <v-btn
                variant="outlined"
                color="primary"
                :size="$vuetify.display.xs ? 'default' : 'large'"
                @click="() => this.$router.push('/admin/pagamentos')"
            >
                Voltar
            </v-btn>
            <v-btn
                variant="flat"
                color="primary"
                :size="$vuetify.display.xs ? 'default' : 'large'"
                @click="editCupom()"
                >Salvar</v-btn
            >
        </div>
    </div>

    <Loader :hasReady="hasReady" />
</template>

<script>
    import { mapState } from 'vuex';
    import { toast } from 'vue3-toastify';
    import Cupom from '@/utils/Weflix/cupom';
    import Plan from '@/utils/Weflix/plan';
    import Loader from '@/components/Weflix/Loader';
    import CustomToggle from '@/components/Form/CustomToggle.vue';

    export default {
        data() {
            return {
                code: '',
                frequenciaRenovacao: '',
                plans: [],
                selectedPlan: '',
                discount: '',
                expired: '',
                hasReady: false,
                id: this.$route.params.slug,
                status: false,
            };
        },
        computed: {
            ...mapState(['token']),
        },
        components: {
            Loader,
            CustomToggle,
        },
        methods: {
            formatDateToISO(date) {
                const d = new Date(date);
                return d.toISOString();
            },
            formatDateToISO(date) {
                const d = new Date(date);
                return d.toISOString();
            },
            formatDate(isoDate) {
                const date = new Date(isoDate);
                const year = date.getUTCFullYear();
                const month = String(date.getUTCMonth() + 1).padStart(2, '0');
                const day = String(date.getUTCDate()).padStart(2, '0');

                return `${year}-${month}-${day}`;
            },
            async editCupom() {
                this.hasReady = false;
                const payload = {
                    title: this.code,
                    code: this.code,
                    defaul: 0,
                    status: this.status == true ? 1 : 0,
                    expired: this.formatDateToISO(this.expired),
                    discount: this.discount,
                    planId: this.selectedPlan,
                };
                try {
                    const response = await Cupom.editCupom(
                        this.token,
                        this.id,
                        payload
                    );
                    this.hasReady = true;
                    this.notify('Cupom editado com sucesso!', 'success');
                } catch (error) {
                    this.notify('Erro ao editar cupom!', 'error');
                    console.error(error);
                }
            },
            async getPlans() {
                try {
                    const response = await Plan.getPlans(this.token);
                    this.plans = response;
                } catch (error) {
                    console.error(error);
                }
            },
            async getCupomById(id) {
                const params = this.$route.params.slug;
                try {
                    const response = await Cupom.getCupomById(
                        this.token,
                        params
                    );
                    this.code = response.code;
                    this.discount = response.discount;
                    this.expired = this.formatDate(response.expired);
                    this.status = response.status == 1 ? true : false;
                    this.hasReady = true;
                } catch (error) {
                    console.error(error);
                }
            },
            notify(message, type = 'info') {
                toast(message, {
                    autoClose: 3000,
                    position: 'top-right',
                    theme: 'light',
                    limit: 1,
                    type: type,
                    dangerouslyHTMLString: true,
                });
            },
        },
        created() {
            this.getPlans();
            this.getCupomById();
        },
    };
</script>

<style scoped>
    @import url(./global.css);

    .contetContainerNewPlan {
        display: flex;
        flex-wrap: wrap;
    }

    .creditCard {
        display: flex;
        flex-wrap: wrap;
        padding: 5px 20px;
        align-items: center;
        text-align: left;
        gap: 21px;
    }
    .boleto {
        display: flex;
        flex-wrap: wrap;
        padding: 5px 20px;
        align-items: center;
        text-align: left;
        gap: 21px;
    }
    .boleto img {
        width: 22px;
        height: 30px;
    }
    .infoCreditCard h4 {
        margin: 0;
        font-size: 16px;
        font-weight: 700;
    }
    .infoCreditCard {
        width: 80%;
    }
    .paymentMethods {
        padding-bottom: 50px;
    }
    .infoCreditCard p {
        margin: 0;
        color: gray;
    }
    @media (max-width: 600px) {
        .weflix-admin-editCupon h3 {
            font-size: 20px;
            margin-bottom: 5px;
        }
        .weflix-admin-editCupon small {
            font-size: 12px;
            color: #666;
        }
        .weflix-admin-editCupon .contetContainerNewPlan {
            padding: 0px 10px;
        }
        .weflix-admin-editCupon .actions {
            padding: 0px 20px;
        }
        .weflix-admin-editCupon .actions .btn {
            width: 100%;
        }
    }
</style>
